import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { adminFetch } from './useAdminApi';

export interface CommsPauseStatus {
  paused: boolean;
  reason: string | null;
  by: string | null;
  at: string | null;
  source: 'env' | 'db' | 'none';
  /** COMMS_PAUSED is set in Netlify — the switch here cannot lift it. */
  env_paused: boolean;
  held_24h: number;
  last_held_at: string | null;
}

const KEY = ['admin', 'comms-pause'];

export function useCommsPause() {
  return useQuery({
    queryKey: KEY,
    queryFn: () => adminFetch<CommsPauseStatus & { ok: true }>('admin-comms-pause'),
    refetchInterval: 30_000,
  });
}

export function useSetCommsPause() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (v: { paused: boolean; reason?: string }) =>
      adminFetch<CommsPauseStatus & { ok: true }>('admin-comms-pause', {
        method: 'POST',
        body: JSON.stringify(v),
      }),
    onSuccess: (data) => qc.setQueryData(KEY, data),
  });
}
